import { useSelector } from 'react-redux';

import { profileSelectors } from '../store/selectors/profile';

const PREVIEW_USER_IDS = [1, 15280];

const useIsTestStudent = () => {
  const profile = useSelector(profileSelectors);
  const user = profile?.user;

  if (!user) {
    return false;
  }

  return Boolean(user.is_test_student) || PREVIEW_USER_IDS.includes(Number(user.id));
};

export default useIsTestStudent;
